import {
  markNotificationRead,
  queryNotifications,
  getUnreadCount,
} from '@/services/notification.service';

const initialState = {
  page: 1,
  list: [],
  isLoading: false,
};

const Model = {
  namespace: 'notifications',
  state: { ...initialState },

  effects: {
    *fetch({ payload }, { call, put, all }) {
      yield {
        type: 'setLoading',
        payload: true,
      };

      try {
        const [notifications, unread] = yield all([
          call(queryNotifications, payload),
          call(getUnreadCount, payload),
        ]);
        yield put({
          type: 'queryList',
          payload: { 
            notifications: notifications.data,
            unread: unread.data 
          },
        });
      } catch (error) {
        yield {
          type: 'setLoading',
          payload: false,
        };
      }
    },

    *appendFetch(_, { call, put, select }) {
      const page = yield select(({ notifications }) => notifications.page);

      yield put({
        type: 'setLoading',
        payload: true,
      });

      try {
        const response = yield call(queryNotifications, { page: page + 1 });
        yield put({
          type: 'appendList',
          payload: response.data,
        });
      } catch (error) {
        // TODO: add logic
      }

      yield put({
        type: 'setLoading',
        payload: false,
      });
    },

    *markRead({ payload }, { call, put }) {
      yield call(markNotificationRead, payload);

      yield put({
        type: 'markRead',
        payload,
      });
    },

    *clearNotifications() {
      yield {
        type: 'clearNotifications',
      };
    },
  },

  reducers: {
    queryList(state, action) {
      return {
        ...state,
        page: 1,
        isLoading: false,
        unread: action.payload.unread,
        total: action.payload.notifications.count,
        list: action.payload.notifications.results,
      };
    },

    setLoading(state, action) {
      return {
        ...state,
        isLoading: action.payload,
      };
    },

    markRead(state, action) {
      const notification = state.list.find((n) => n.id === action.payload);
      notification.read = true;
      notification.unread = false;
      if (notification.unread) {
        return { ...state, list: [...state.list], unread: state.unread - 1 };
      }
      return { ...state, list: [...state.list] };
    },

    clearNotifications() {
      return { ...initialState };
    },

    appendList(state, action) {
      return { ...state, list: state.list.concat(action.payload.results), page: state.page + 1 };
    },
  },
};
export default Model;
